module.exports = __webpack_public_path__ + "img/auth-forget-background.e77c6c0c.png";